import React, { useRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import {
    FixedTxt
} from "view/images/index";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay } from "swiper";

function Section04({ inView3, ref3 }) {

    return (
        <React.Fragment>
            <article
                ref={ref3}
                className={classNames("section04", {
                    on: inView3 == true,
                })}>
                <div className="wrap">
                    <div className="mobile-on">

                        <div className="mobile-center-left">반응형도</div>
                        <div className="mobile-center-right">좋아합답니다.</div>

                        <Swiper
                            breakpoints={{
                                // when window width is >= 640px
                                360: {
                                    slidesPerView: 2,
                                },
                                // when window width is >= 768px
                                768: {
                                    slidesPerView: 2,
                                    centeredSlides: true,
                                },

                                1199: {
                                    slidesPerView: 4,
                                },
                            }}
                            effect={"fade"}
                            loop={true}
                            autoplay={{
                                delay: 1300,
                                disableOnInteraction: false,
                            }}
                            slidesPerView={5}
                            centeredSlides={true}
                            //spaceBetween={30}
                            pagination={{
                                clickable: false,
                            }}
                            modules={[Autoplay]}
                            className="mySwiper"
                        >
                            <SwiperSlide>
                                <img src="/images/cloud.png" />
                                <img src="/images/phone_image2.png" />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src="/images/portfolio.jpg" />
                                <img src="/images/phone_image.png" />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src="/images/cloud.png" />
                                <img src="/images/phone_image2.png" />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src="/images/portfolio.jpg" />
                                <img src="/images/phone_image.png" />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src="/images/cloud.png" />
                                <img src="/images/phone_image2.png" />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src="/images/portfolio.jpg" />
                                <img src="/images/phone_image.png" />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src="/images/cloud.png" />
                                <img src="/images/phone_image2.png" />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src="/images/portfolio.jpg" />
                                <img src="/images/phone_image.png" />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src="/images/cloud.png" />
                                <img src="/images/phone_image2.png" />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src="/images/portfolio.jpg" />
                                <img src="/images/phone_image.png" />
                            </SwiperSlide>
                        </Swiper>
                        <div className="mobile-pic">
                            <img src="/images/phone.png" />
                        </div>
                    </div>

                </div >

            </article >
        </React.Fragment >
    );
}

export default connect(
    // props 로 넣어줄 스토어 상태값
    (state) => ({
        layout: state.layout,
    })
)(Section04);

